import { render, staticRenderFns } from "./right.vue?vue&type=template&id=e42ecb30&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42ecb30",
  null
  
)

export default component.exports